<!-- 统计报表 -->

<template>
    <div class="view-container">
      <!-- 筛选头部 -->
      <div class="sizer-view" v-if="sizerOpne == 0" @click="sizerOpne = 1">
        <el-button type="primary">导出记录</el-button>
        <div style="margin-left: 10px">筛选</div>
        <img src="@/assets/image/shaixuan.png" alt="" />
      </div>
      <!-- 筛选内容 -->
      <div class="sizer-content" v-else>
        <div class="flex-column-item" style="margin-top: 20px">
          <el-date-picker
            style="width: 430px"
            v-model="value1"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="center"
          >
          </el-date-picker>
          <el-input
            v-model="value2"
            placeholder="请输入内容"
            style="width: 430px"
          ></el-input>
          <div style="width: 430px">
            <el-select v-model="value3" placeholder="请选择" style="width: 100%">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-column-item" style="margin-top: 20px">
          <div style="width: 430px">
            <el-select v-model="value3" placeholder="请选择" style="width: 100%">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="fold-view">
            <el-button size="small">重置</el-button>
            <el-button type="primary" size="small">查询</el-button>
            <div
              @click="sizerOpne = 0"
              style="padding: 0px 10px; font-size: 16px; color: #488eff"
            >
              收起
            </div>
          </div>
        </div>
      </div>
      <div class="hint-view">
        <img src="@/assets/image/hint-image.png" alt="">
        <label > 全部订单中取消订单、修改折扣是按单卡处理，如果需要批量修改可在批量订单中操作。 </label>
      </div>
      <!-- 表格 -->
      <div class="tab-view">
        <el-table
          :data="tableData"
          style="width: 100%"
          max-height="300"
          :header-cell-style="{
            backgroundColor: ' rgb(235, 237, 244)',
            color: 'black',
            fontSize: '14px',
            fontWeight: '600',
          }"
        >
          <el-table-column fixed prop="date" label="提交时间" width="150">
          </el-table-column>
          <el-table-column prop="name" label="订单号" width="120">
          </el-table-column>
          <el-table-column prop="province" label="批量订单号" width="120">
          </el-table-column>
          <el-table-column prop="city" label="类型" width="120">
          </el-table-column>
          <el-table-column prop="address" label="变动金额" width="300">
          </el-table-column>
          <el-table-column prop="zip" label="变动前金额" width="120">
          </el-table-column>
          <el-table-column prop="zip" label="变动后金额" width="120">
          </el-table-column>
          <el-table-column prop="zip" label="备注" width="120"> </el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="deleteRow(scope.$index, tableData)"
                type="text"
                size="small"
              >
                移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div style="margin-top: 30px; display: flex; justify-content: flex-end;padding-right: 30px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="400"
        >
        </el-pagination>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        sizerOpne: 0,
        pickerOptions: {
          shortcuts: [
            {
              text: "本月",
              onClick(picker) {
                picker.$emit("pick", [new Date(), new Date()]);
              },
            },
            {
              text: "今年至今",
              onClick(picker) {
                const end = new Date();
                const start = new Date(new Date().getFullYear(), 0);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近六个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setMonth(start.getMonth() - 6);
                picker.$emit("pick", [start, end]);
              },
            },
          ],
        },
        value1: "",
        value2: "",
        value3: "",
        currentPage4: 4,
        tableData: [
          {
            date: "2016-05-03",
            name: "王小虎",
            province: "上海",
            city: "普陀区",
            address: "上海市普陀区金沙江路 1518 弄",
            zip: 200333,
          },
          {
            date: "2016-05-02",
            name: "王小虎",
            province: "上海",
            city: "普陀区",
            address: "上海市普陀区金沙江路 1518 弄",
            zip: 200333,
          },
          {
            date: "2016-05-04",
            name: "王小虎",
            province: "上海",
            city: "普陀区",
            address: "上海市普陀区金沙江路 1518 弄",
            zip: 200333,
          },
          {
            date: "2016-05-01",
            name: "王小虎",
            province: "上海",
            city: "普陀区",
            address: "上海市普陀区金沙江路 1518 弄",
            zip: 200333,
          },
          {
            date: "2016-05-08",
            name: "王小虎",
            province: "上海",
            city: "普陀区",
            address: "上海市普陀区金沙江路 1518 弄",
            zip: 200333,
          },
          {
            date: "2016-05-06",
            name: "王小虎",
            province: "上海",
            city: "普陀区",
            address: "上海市普陀区金沙江路 1518 弄",
            zip: 200333,
          },
          {
            date: "2016-05-07",
            name: "王小虎",
            province: "上海",
            city: "普陀区",
            address: "上海市普陀区金沙江路 1518 弄",
            zip: 200333,
          },
        ],
      };
    },
    methods: {
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .sizer-view {
    padding: 0px 30rpx;
    display: flex;
    align-items: center;
    font-size: 16px;
    height: 80px;
    color: #488eff;
    font-weight: 600;
    background-color: white;
    padding-left: 30px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  
    img {
      width: 24px;
      height: 24px;
      margin-left: 10px;
    }
  }
  
  .sizer-content {
    height: 150px;
    background-color: white;
    padding: 0px 30px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    .flex-column();
  
    .flex-column-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
  
      .fold-view {
        display: flex;
        align-items: center;
      }
    }
  }
  
  .view-container {
    background-color: white;
    height: 100%;
    .hint-view{
      margin: 0px 30px;
      height: 40px;
      color: rgb(169, 83, 0);
      background: rgb(255, 244, 219);
      display: flex;
      align-items: center;
      font-size: 12px;
      color: rgb(169, 83, 0);
      padding: 0px 20px;
      border-radius: 10px;
      img{
        width: 28px;
        height: 28px;
        margin-right: 10px;
      }
    }
    .tab-view {
      border: 2px solid #ebeef5;
      margin: 0px 30px;
      border-radius: 5px;
      margin-top: 20px;
    }
  }
  </style>
  